__turbopack_context__.v({
  "sectionHeader": "SectionHeader-module-scss-module__7LuVqq__sectionHeader",
  "sectionHeaderBlueTitle": "SectionHeader-module-scss-module__7LuVqq__sectionHeaderBlueTitle",
  "sectionHeaderCenteredTextOnly": "SectionHeader-module-scss-module__7LuVqq__sectionHeaderCenteredTextOnly",
  "sectionHeaderCenteredTitle": "SectionHeader-module-scss-module__7LuVqq__sectionHeaderCenteredTitle",
  "sectionHeaderDefault": "SectionHeader-module-scss-module__7LuVqq__sectionHeaderDefault",
  "sectionHeaderDefaultTitle": "SectionHeader-module-scss-module__7LuVqq__sectionHeaderDefaultTitle",
  "sectionHeaderHeader": "SectionHeader-module-scss-module__7LuVqq__sectionHeaderHeader",
  "sectionHeaderHeaderCentered": "SectionHeader-module-scss-module__7LuVqq__sectionHeaderHeaderCentered",
  "sectionHeaderText": "SectionHeader-module-scss-module__7LuVqq__sectionHeaderText",
  "sectionHeaderTextCta": "SectionHeader-module-scss-module__7LuVqq__sectionHeaderTextCta",
  "sectionHeaderTitle": "SectionHeader-module-scss-module__7LuVqq__sectionHeaderTitle",
  "textOnlyCenteredList": "SectionHeader-module-scss-module__7LuVqq__textOnlyCenteredList",
});
